import { render, staticRenderFns } from "./preview-count-stats.vue?vue&type=template&id=207d2ff5&scoped=true&"
import script from "./preview-count-stats.vue?vue&type=script&lang=ts&"
export * from "./preview-count-stats.vue?vue&type=script&lang=ts&"
import style0 from "./preview-count-stats.vue?vue&type=style&index=0&id=207d2ff5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207d2ff5",
  null
  
)

export default component.exports